"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var gddTypes_1 = require("@_types/gddTypes");
var form_style = __importStar(require("./GDDForm.module.scss"));
var button_styles = __importStar(require("@components/Buttons/Button.module.scss"));
var react_redux_1 = require("react-redux");
var useClearOnTime_1 = __importDefault(require("@hooks/useClearOnTime"));
var react_router_dom_1 = require("react-router-dom");
var react_modal_1 = __importDefault(require("react-modal"));
var useCurrentLanguage_1 = require("@hooks/useCurrentLanguage");
var gddFormTranslator_1 = require("./localisation/gddFormTranslator");
var gddAPI_1 = require("@services/gddAPI");
var authSlice_1 = require("@store/slices/authSlice");
var loaderSlice_1 = require("@store/slices/loaderSlice");
function NewGDDForm(_a) {
    var isVisible = _a.isVisible, setVisible = _a.setVisible;
    var _b = (0, react_1.useActionState)(handleSubmit, undefined), data = _b[0], action = _b[1], isPending = _b[2];
    var _c = (0, react_1.useState)(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var dispatch = (0, react_redux_1.useDispatch)();
    var navigate = (0, react_router_dom_1.useNavigate)();
    var currentLang = (0, useCurrentLanguage_1.useCurrentLanguage)();
    var loc = gddFormTranslator_1.gddFormTranslator[currentLang];
    (0, useClearOnTime_1.default)({ setText: setErrorMessage, text: errorMessage });
    function handleSubmit(prevValue, data) {
        return __awaiter(this, void 0, void 0, function () {
            var title, genre, view, platform, gddResponse, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        title = data.get("title");
                        genre = data.get("genre");
                        view = data.get("view");
                        platform = data.get("platform");
                        if (title.length <= 0) {
                            setErrorMessage(loc.titleRequired);
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, 4, 5]);
                        dispatch((0, loaderSlice_1.setLoading)(true));
                        return [4 /*yield*/, (0, gddAPI_1.createGDDAPI)(title, genre, view, platform)];
                    case 2:
                        gddResponse = _a.sent();
                        if (gddResponse.success) {
                            dispatch((0, authSlice_1.setSelectedGDD)(gddResponse.gdd.id));
                            handleCloseModal();
                            navigate("/gdd/info");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _a.sent();
                        console.log("error", error_1);
                        return [3 /*break*/, 5];
                    case 4:
                        dispatch((0, loaderSlice_1.setLoading)(false));
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function handleCloseModal() {
        setVisible(false);
    }
    return ((0, jsx_runtime_1.jsx)(react_modal_1.default, { isOpen: isVisible, ariaHideApp: false, style: {
            content: { border: "none", background: "none" },
        }, children: (0, jsx_runtime_1.jsxs)("form", { action: action, className: form_style.general_info_form, children: [(0, jsx_runtime_1.jsx)("h2", { children: "Game Design Document (GDD)" }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "title", children: loc.title }), (0, jsx_runtime_1.jsx)("input", { "data-testid": "title_input", type: "text", id: "title", name: "title" })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "genre", children: loc.genre }), (0, jsx_runtime_1.jsx)("input", { type: "text", id: "genre", name: "genre", required: true })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "view", children: loc.view }), (0, jsx_runtime_1.jsx)("select", { id: "view", name: "view", defaultValue: gddTypes_1.GameView.FirstPerson, children: Object.values(gddTypes_1.GameView).map(function (view) { return ((0, jsx_runtime_1.jsx)("option", { value: view, children: view }, view)); }) })] }), (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_group, children: [(0, jsx_runtime_1.jsx)("label", { htmlFor: "platform", children: loc.platform }), (0, jsx_runtime_1.jsx)("select", { id: "platform", name: "platform", defaultValue: gddTypes_1.GamePlatform.PC, children: Object.values(gddTypes_1.GamePlatform).map(function (platform) { return ((0, jsx_runtime_1.jsx)("option", { value: platform, children: platform }, platform)); }) })] }), errorMessage.length > 0 ? ((0, jsx_runtime_1.jsx)("div", { className: "".concat(form_style.form_group, " ").concat(form_style.error), children: errorMessage })) : null, (0, jsx_runtime_1.jsxs)("div", { className: form_style.form_footer, children: [(0, jsx_runtime_1.jsx)("button", { type: "submit", className: button_styles.create_btn, children: loc.saveButton }), (0, jsx_runtime_1.jsx)("button", { "data-testid": "close_modal", type: "button", className: button_styles.cancel_btn, onClick: handleCloseModal, children: loc.closeButton })] })] }) }));
}
exports.default = NewGDDForm;
